import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 THE MENORESET SYSTEM™',
  ideal: 'Any woman wishing to regain physical control, erase painful symptoms naturally, and balance her hormones from scratch',
  was: '$38',
  now: '$19',
  features: ['6 Complete Tomes (60+ pages)', 'Metabolic Cooling and Sleep protocols', 'Real fat-burning & mental clarity frameworks', '30-Day routine with visible hormonal health', '3 Free Premium Bonuses included', '7-Day Money-Back Guarantee', 'Lifetime access & free updates'],
  cta: 'Get The MenoReset System™'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-128" data-mp="3vyx8s3w8o6h5">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-129" data-mp="4rkrlovcvt18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} id="checkout-card" className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(168,90,90,0.45)]" style={{
        paddingTop: "5px",
        paddingBottom: "5px"
      }} data-id="element-130" data-mp="9q5s7peiseq7">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-131" data-mp="3ryn5x03qtw6i">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-132" data-mp="2uj98n8g2c5pa">
            <span className="font-semibold text-plum/80" data-id="element-133" data-mp="2ugn2nd8tly96">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-134" data-mp="2zf7rkgimgvib">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "29px"
          }} data-id="element-135" data-mp="2rgcyy442ytzh">{plan.was}</span>
            <div className="grid grid-cols-[1fr_auto_1fr] items-baseline gap-1.5 pb-5 pt-3 font-display text-grape" aria-label="19 USD" style={{
            paddingBottom: "10px"
          }} data-id="element-136" data-mp="2mh08zahwx6so">
              <span className="justify-self-end text-[40px] font-black leading-none" aria-hidden="true" style={{
              paddingTop: "18px"
            }} data-id="element-137" data-mp="2w71ovf043iwi">
                $
              </span>
              <span className="text-[96px] font-black leading-none tracking-tight" aria-hidden="true" data-id="element-138" data-mp="23ixi0q5t0zs8">
                19
              </span>
              <span className="justify-self-start text-[26px] font-extrabold leading-none" aria-hidden="true" data-id="element-139" data-mp="2igy7b1c6gdde">
                USD
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-140" data-mp="3tutwz40pk4iv">
              · One-time payment ·
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-141" data-mp="3ov781xbiozu8">
              Payment will be processed in your local currency.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-142" data-mp="59gr6e6vm5sk">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-143" data-mp="5742li6m4x6j">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-144" data-mp="3nh68wcylbni2" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-145" data-mp="j0lhuqs9nnqr">
            <CTAButton size="md" data-id="element-146" data-mp="j37qyuut2bb3">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" data-id="element-147" data-mp="nzgdwuf8v8st">
            You save $112 USD (85% OFF)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-148" data-mp="ea55zb43ga6i">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-149" data-mp="11xmr4nsusa0i">
                <Icon className="h-4 w-4 text-grape" data-id="element-150" data-mp="16s0notj94n6r" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-151" data-mp="3a8fdyixsfidy" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-152" data-mp="3a85yvqea6vn1">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-153" data-mp="359mcjovrzhu5" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-154" data-mp="3192f0k7aic7h">
            <span className="font-display font-bold text-plum" data-id="element-155" data-mp="1scf92onl41r">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel the system does not match your expectations or does
            not give you the relief you were looking for, simply request your refund and we return
            100% of your money. We want you to balance your body with complete peace of mind,
            risk-free.
          </p>
        </div>
      </div>
    </section>;
}